import CommonTabComp from "./CommonTabComp";

const CompletedDocsTab = ({
  onClickSearch,
  onClickFavorite,
  onClickNewDraft,
  totalPage,
  searchResult,
}) => {
  return (
    <div style={{ minHeight: "40rem" }}>
      <CommonTabComp
        tabType="completed"
        onClickSearch={onClickSearch}
        onClickFavorite={onClickFavorite}
        onClickNewDraft={onClickNewDraft}
        totalPage={totalPage}
        searchResult={searchResult}
      />
    </div>
  );
};
export default CompletedDocsTab;
